import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'ui-steps-progress',
  templateUrl: './steps-progress.component.html',
  styleUrls: ['./steps-progress.component.scss']
})
export class StepsProgressComponent {

  @Input('stepNumber') stepNumber: number = 1;
  @Input('steps') stepsInput: any[] = [];
  @Input() typeOfRegistration!: string;
  @Output() exitOnboarding = new EventEmitter<void>();


/*  stepsNumber: any[] = [
      {id: 1, title: 'Tipologia di account', text: "Seleziona una tipologia di account"},
      {id: 2, title: 'Info genitore', text: "Inserisci le informazioni riferite al genitore"},
      {id: 3, title: 'Info atleta/i', text: "Inserisci le informazioni riferite all'atleta"},
      {id: 4, title: 'Condizioni del servizio', text: "Accettazione dei termini e condizioni del servizio."},
      {id: 5, title: 'Invio registrazione', text: ""},
  ];*/

  currentStep: number = 1;
  steps: any;

  ngOnInit() {
    this.steps = this.stepsInput;
    
  }

  ngOnChanges(){
      this.currentStep = this.stepNumber;
    this.steps = this.stepsInput;

    console.log("reg:", this.typeOfRegistration)

  }

  getRegistrationValue() {
    if (this.typeOfRegistration === 'agent') {
      return 'AGENTE';
    } else if (this.typeOfRegistration === 'athlete') {
      return 'GENITORE O TUTORE';
    } else if (this.typeOfRegistration === 'company') {
      return 'SOCIETÀ';
    } else if (this.typeOfRegistration === 'staff') {
      return 'STAFF / PERSONALE';
    } else {
      return 'ONBOARDING SOCIETÀ';
    }
  }
}
